import { useCountryData, useProvinceData } from "@/hooks/shopify-hooks/api/useAddressApi.js";
import { useExposeCsrContext } from "@/hooks/common/use-expose-csr-context";
import {_SHOPIFY_ADDRESS_API_DATA } from "@/hooks/common/use-expose-csr-context/constants";
import { getLang } from "@/utils/tools";

export const getCountry = async () => {
    if (window?.csr?.addressApiData?.country) {
        return window.csr.addressApiData.country;
      } else {
        const { data } = await useCountryData();
        const countries = data?.value?.countries || []
        useExposeCsrContext({
            key: _SHOPIFY_ADDRESS_API_DATA,
            data: {
                country: countries
            },
        });
        return countries;
    }
}


export const getProvince = async (countryId) => {
    if (window?.csr?.addressApiData?.province?.[countryId]) {
        return window?.csr?.addressApiData?.province?.[countryId];
      } else {
        const { data } = await useProvinceData(countryId, getLang());
        const provinces = data?.value?.provinces || []
        useExposeCsrContext({
            key: _SHOPIFY_ADDRESS_API_DATA,
            data: {
                province: {
                    [countryId]: provinces
                }
            },
        });
        return provinces;
    }
}